/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FullTranscriptUi,
  TranscriptAnalyticsRequest,
  TranscriptAnalyticsResponse,
  TranscriptTableRequest,
  TranscriptTableResponse,
} from '../models';

export interface GetTranscriptAnalyticsRequest {
    transcriptAnalyticsRequest: TranscriptAnalyticsRequest;
}

export interface GetTranscriptTableRequest {
    transcriptTableRequest: TranscriptTableRequest;
}

export interface GetUserTranscriptRequest {
    userId: number;
    conversationChannel: GetUserTranscriptConversationChannelEnum;
}

/**
 * 
 */
export class TranscriptApiControllerApi extends runtime.BaseAPI {

    /**
     */
    async getTranscriptAnalyticsRaw(requestParameters: GetTranscriptAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscriptAnalyticsResponse>> {
        if (requestParameters['transcriptAnalyticsRequest'] == null) {
            throw new runtime.RequiredError(
                'transcriptAnalyticsRequest',
                'Required parameter "transcriptAnalyticsRequest" was null or undefined when calling getTranscriptAnalytics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/transcript/analytics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['transcriptAnalyticsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTranscriptAnalytics(requestParameters: GetTranscriptAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscriptAnalyticsResponse> {
        const response = await this.getTranscriptAnalyticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTranscriptTableRaw(requestParameters: GetTranscriptTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranscriptTableResponse>> {
        if (requestParameters['transcriptTableRequest'] == null) {
            throw new runtime.RequiredError(
                'transcriptTableRequest',
                'Required parameter "transcriptTableRequest" was null or undefined when calling getTranscriptTable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/private/transcript/table`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['transcriptTableRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTranscriptTable(requestParameters: GetTranscriptTableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranscriptTableResponse> {
        const response = await this.getTranscriptTableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserTranscriptRaw(requestParameters: GetUserTranscriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullTranscriptUi>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserTranscript().'
            );
        }

        if (requestParameters['conversationChannel'] == null) {
            throw new runtime.RequiredError(
                'conversationChannel',
                'Required parameter "conversationChannel" was null or undefined when calling getUserTranscript().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['conversationChannel'] != null) {
            queryParameters['conversationChannel'] = requestParameters['conversationChannel'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/private/transcript/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUserTranscript(requestParameters: GetUserTranscriptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullTranscriptUi> {
        const response = await this.getUserTranscriptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetUserTranscriptConversationChannelEnum = {
    Widget: 'WIDGET',
    SuperchatWhatsApp: 'SUPERCHAT_WHATS_APP',
    SuperchatEmail: 'SUPERCHAT_EMAIL',
    SuperchatSms: 'SUPERCHAT_SMS',
    SuperchatTelegram: 'SUPERCHAT_TELEGRAM',
    SuperchatInstagram: 'SUPERCHAT_INSTAGRAM',
    SuperchatFacebook: 'SUPERCHAT_FACEBOOK',
    ContactCenterWhatsApp: 'CONTACT_CENTER_WHATS_APP',
    ContactCenterEmail: 'CONTACT_CENTER_EMAIL',
    ContactCenterSms: 'CONTACT_CENTER_SMS',
    ConfidentAi: 'CONFIDENT_AI'
} as const;
export type GetUserTranscriptConversationChannelEnum = typeof GetUserTranscriptConversationChannelEnum[keyof typeof GetUserTranscriptConversationChannelEnum];
